import React from "react";
import { NavLink } from "react-router-dom";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const TopNav = ({
  tabs,
  style,
  parentPath,
  navigationState,
  setNavigationState,
  isFullWidth,
  borderless,
  sticky,
}) => {
  const translateTab = staticDataHooks.useTranslator("tabs");

  const tabList = tabs.map((tab) => (
    <NavLink
      key={tab.title}
      to={tab.path}
      className={({ isActive }) =>
        "top-nav-tab " + (isActive ? "active-tab" : "")
      }
      onClick={() => {
        if (setNavigationState) {
          setNavigationState({
            ...navigationState,
            [parentPath]: tab.path,
          });
        }
      }}
      data-testid={`child-tab-${tab.path}`}
    >
      {translateTab(`${parentPath}/${tab.path}`, { default: tab.title })}
    </NavLink>
  ));
  return (
    <div
      className={`top-nav no-print ${sticky ? "sticky" : ""} ${
        borderless ? "borderless" : ""
      }`}
      style={style}
    >
      <div className={isFullWidth ? "container full-width" : "container"}>
        {tabList}
      </div>
    </div>
  );
};

export default TopNav;
